export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50 mb-4">爱漫画网</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              专注提供下拉式漫画阅读、翻页漫画与无弹窗漫画体验。支持漫画全屏观看，
              让免费看漫画全集更流畅，沉浸式追漫体验从这里开始。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">阅读模式</h4>
            <ul className="space-y-2.5">
              <li><a href="#features" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">下拉式漫画阅读</a></li>
              <li><a href="#features" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">翻页漫画模式</a></li>
              <li><a href="#features" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">无弹窗漫画阅读</a></li>
              <li><a href="#features" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">漫画全屏观看</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#updates" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">漫画快讯</a></li>
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">人气榜单</a></li>
              <li><a href="#faq" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              我们与众多优质内容平台保持合作，持续为用户提供更丰富的漫画阅读资源和更流畅的在线阅读体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {new Date().getFullYear()} 爱漫画网 - 沉浸式漫画阅读平台，保留所有权利。
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-background-400 hover:text-primary-400 transition-colors text-sm cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}